import { QuestionnaireQuestion } from "@repo/api";
import { FC } from "react";
import { useFormContext } from "react-hook-form";
import { CheckboxInput, Fieldset } from "../../Form";
import * as Styled from "./QuestionnairePage.styled";

export const QuestionnaireQuestionMultipleChoices: FC<{
    question: QuestionnaireQuestion;
}> = ({ question }) => {
    const { trigger } = useFormContext();

    return (
        <Fieldset name={`${question.id}`}>
            {question.answers?.map((answer) => (
                <CheckboxInput
                    key={`${question.id}-${answer.id}`}
                    name={`${question.id}.${answer.id}`}
                    label={answer.text}
                    LabelTextComponent={Styled.QuestionnaireQuestionAnswerLabel}
                    afterChange={() => {
                        trigger(`${question.id}`);
                    }}
                />
            ))}
        </Fieldset>
    );
};
